/**
 * Alpine component: dashboardTest
 *
 * Gestisce la pagina Test ECM della dashboard:
 * - Tab switching pendenti (SSR) / completati (lazy-load)
 * - Bridge verso quizPlayer per avviare quiz o survey
 * - Refresh pagina dopo completamento
 */
export function registerDashboardTest(Alpine) {
    Alpine.data('dashboardTest', (config) => ({
        // Tab
        activeTab: 'pending',
        tabLoading: false,
        completedItems: null,

        // Config da SSR
        allSubIds: config.allSubIds || [],
        ajaxBase: config.ajaxBase || '/ajax',

        // Quiz/Survey player bridge
        playerSubId: 0,
        playerQuizzes: [],
        playerActive: false,
        surveyPlayerActive: false,

        init() {},

        /**
         * Cambia tab. "pending" è SSR, "completed" lazy-load.
         */
        async switchTab(tab) {
            if (tab === this.activeTab) return;
            this.activeTab = tab;

            if (tab === 'pending') return;
            if (this.completedItems !== null) return;

            this.tabLoading = true;
            try {
                const items = [];
                for (const subId of this.allSubIds) {
                    const [training, sub] = await Promise.all([
                        this._apiFetch('/v1/users/me/subscriptions/' + subId + '/training'),
                        this._apiFetch('/v1/users/me/subscriptions/' + subId),
                    ]);
                    const courseTitle = sub?.course?.title || sub?.course?.short_title || 'Corso';
                    const courseCode = sub?.course?.code || '';

                    // Quiz superati
                    for (const q of (training?.quizzes || [])) {
                        if (q.passed) {
                            items.push({
                                id: q.id,
                                type: 'quiz',
                                subscription_id: subId,
                                course_title: courseTitle,
                                course_code: courseCode,
                            });
                        }
                    }
                    // Survey completati
                    for (const s of (training?.surveys || [])) {
                        if (s.completed) {
                            items.push({
                                id: s.id,
                                type: 'survey',
                                subscription_id: subId,
                                course_title: courseTitle,
                                course_code: courseCode,
                            });
                        }
                    }
                }
                this.completedItems = items;
            } catch (e) {
                this.completedItems = [];
            } finally {
                this.tabLoading = false;
            }
        },

        /**
         * Avvia il player per un quiz o survey.
         */
        launchQuiz(subId, itemId, itemTitle, type) {
            this.playerSubId = subId;
            this.playerQuizzes = [{ id: itemId, title: itemTitle, passed: false, type: type || 'quiz' }];
            if (type === 'survey') {
                this.surveyPlayerActive = true;
            } else {
                this.playerActive = true;
            }
        },

        /**
         * Chiamato dopo la chiusura del player.
         */
        onPlayerClosed() {
            this.playerActive = false;
            this.surveyPlayerActive = false;
            this.completedItems = null; // invalida cache completati
            this.refreshPending();
        },

        async refreshPending() {
            try {
                const data = await this._apiFetch('/v1/users/me/pending-quizzes');
                const serverCount = data?.total_items ?? 0;
                const currentRows = this.$root.querySelectorAll('[data-quiz-row]').length;
                if (serverCount !== currentRows) {
                    window.location.reload();
                }
            } catch (e) { /* silent */ }
        },

        /**
         * Fetch API con Auth-Token header.
         */
        async _apiFetch(path) {
            const apiBase = window.IKOS?.apiBase || '';
            const headers = { 'Accept': 'application/json' };
            const authToken = window.IKOS?.authToken;
            if (authToken && authToken !== true) {
                headers['Auth-Token'] = authToken;
            }
            const guestId = window.IKOS?.guestId;
            if (guestId) headers['X-Guest-Id'] = guestId;
            const res = await fetch(apiBase + path, { headers });
            if (!res.ok) throw new Error('API ' + res.status);
            return res.json();
        },
    }));
}
